import React from 'react';

interface NexusLogoProps {
  size?: 'sm' | 'md' | 'lg' | 'xl';
  className?: string;
}

export const NexusLogo: React.FC<NexusLogoProps> = ({ 
  size = 'lg', 
  className = '' 
}) => {
  const getSizeClasses = () => {
    switch (size) {
      case 'sm':
        return 'text-lg md:text-xl';
      case 'md':
        return 'text-xl md:text-2xl';
      case 'lg':
        return 'text-2xl md:text-4xl';
      case 'xl':
        return 'text-3xl md:text-5xl';
      default:
        return 'text-2xl md:text-4xl';
    }
  };

  return (
    <>
      <style>{`
        .nexus-static {
          background: linear-gradient(45deg, #7c3aed, #7c3aed, #6d28d9);
          -webkit-background-clip: text;
          -webkit-text-fill-color: transparent;
          background-clip: text;
          -webkit-text-stroke: 1px rgba(255, 255, 255, 0.1);
        }
      `}</style>
      <span 
        className={`
          nexus-static
          font-bold tracking-tight inline-block
          ${getSizeClasses()}
          ${className}
        `}
      >
        Nexus
      </span>
    </>
  );
};

export default NexusLogo; 